import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { _className, ComponentSync, LL_H_C, LL_V_L, TS_ErrorBoundary } from '@nu-art/thunderstorm-frontend/index';
import { FadeScrollWrapper, ScrollBar } from '@app/styles';
import './AdvisorMiniPanel.scss';
import { Advisor_ErrorBoundary } from '../../components/Advisor_ErrorBoundary/Advisor_ErrorBoundary.js';
import { ModuleFE_AdvisorMini } from '../../../modules/ModuleFE_AdvisorMini.js';
import { ModuleFE_AdvisorSession } from '@app/advisor-frontend';
export class AdvisorMiniPanel extends ComponentSync {
    //######################### Static #########################
    //React Ref object to connect between the content under fade scroll and the scrollbar component
    scrollRef = React.createRef();
    panelRef = React.createRef();
    //######################### Life Cycle #########################
    __onAdvisorMiniChange = () => {
        //@ts-ignore - Force change focused panel
        this.state.focusedPanel = ModuleFE_AdvisorMini.getCurrentFocusedPanel() === this.props.panelKey;
        this.forceUpdate();
    };
    deriveStateFromProps(nextProps, state) {
        state.focusedPanel ??= ModuleFE_AdvisorMini.getCurrentFocusedPanel() === nextProps.panelKey;
        state.providerType ??= ModuleFE_AdvisorSession.getUserType();
        return state;
    }
    _constructor() {
        const deriveFunc = this.deriveStateFromProps;
        this.deriveStateFromProps = (nextProps, state) => {
            try {
                return deriveFunc.bind(this)(nextProps, state);
            }
            catch (err) {
                this.logError(err);
                return { error: err };
            }
        };
    }
    //######################### Logic #########################
    /**
     * Used to build the class of the panel.
     * When implemented in an inheriting class, should chain result with super.getPanelClass;
     */
    getPanelClass() {
        return _className('advisor-mini-panel', this.props.panelType, this.props.panelKey === ModuleFE_AdvisorMini.getCurrentFocusedPanel() && 'focused-panel');
    }
    /**
     * Used to build the style of the panel
     * When implemented in an inheriting class, should chain result with super.getPanelStyle;
     */
    getPanelStyle() {
        return {};
    }
    onPanelClick = undefined;
    _onPanelClick = (e) => {
        //Quick exit if no logic for click
        if (!this.onPanelClick)
            return;
        //By default, ignore the event if the original clicked item is an icon
        if (e.target.classList.contains('icon--wrapper'))
            return;
        this.onPanelClick(e);
    };
    //######################### Render #########################
    render() {
        const className = this.getPanelClass();
        return _jsx(TS_ErrorBoundary, { renderer: (e) => _jsx(Advisor_ErrorBoundary, { dir: this.state.focusedPanel ? 'vertical' : 'horizontal', error: e, panelKey: this.props.panelKey, onClick: () => {
                    this.reDeriveState({ error: undefined });
                } }), error: this.state.error, children: _jsxs(LL_H_C, { className: className, innerRef: this.panelRef, onClick: this._onPanelClick, "data-panel-key": this.props.panelKey, children: [_jsxs(LL_V_L, { className: 'advisor-mini-panel__main', children: [this.renderHeader(), this._renderSubHeader(), this._renderContent(this.scrollRef), this._renderFooter()] }), _jsx(ScrollBar, { scrollableRef: this.scrollRef }), this.render_extraPanelContent()] }) });
    }
    renderHeader = () => {
        try {
            const headerTitle = this.renderHeader_Title();
            const headerTail = this.renderHeader_Tail?.();
            return _jsxs(LL_H_C, { className: 'advisor-mini-panel__header', children: [_jsx("div", { className: 'advisor-mini-panel__header__title', children: headerTitle }), _jsx(LL_H_C, { className: 'advisor-mini-panel__header__tail', children: headerTail })] });
        }
        catch (error) {
            if (!this.state.error)
                this.setState({ error });
        }
    };
    _renderSubHeader = () => {
        try {
            const subHeader = this.renderSubHeader?.(); // other approach doesn't allow me to return undefined without adding redundant element to the panel
            if (!subHeader)
                return;
            return _jsx("div", { className: 'advisor-mini-panel__sub-header', children: subHeader });
        }
        catch (error) {
            if (!this.state.error)
                this.setState({ error });
        }
    };
    /**
     * This is the function called from render() to get the content of the panel.
     * ONLY OVERWRITE THIS IF YOU KNOW WHAT YOU ARE DOING!
     * @param scrollRef
     */
    _renderContent(scrollRef) {
        try {
            const content = this.renderContent();
            return _jsx(FadeScrollWrapper, { className: 'advisor-mini-panel__content', scrollRef: scrollRef, children: content });
        }
        catch (error) {
            if (!this.state.error)
                this.setState({ error });
        }
    }
    _renderFooter = () => {
        if (!this.renderFooter)
            return;
        try {
            const footer = this.renderFooter();
            return _jsx("div", { className: 'advisor-mini-panel__footer', children: footer });
        }
        catch (error) {
            if (!this.state.error)
                this.setState({ error });
        }
    };
    render_extraPanelContent = () => null;
}
//# sourceMappingURL=AdvisorMiniPanel.js.map